import React from 'react';

const OrderSettingsPanel = ({ formData, setFormData, availableLocations }) => {
  return (
    <div style={{ padding: '0.5rem', backgroundColor: 'var(--bg)', borderRadius: '4px', borderLeft: '3px solid var(--info)' }}>
      <h4 style={{ margin: '0 0 0.4rem 0', fontSize: '11px', fontWeight: '600', color: 'var(--text-secondary)' }}>
        Ustawienia zamowienia
      </h4>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.4rem', fontSize: '10px' }}>
        <div>
          <span style={{ color: 'var(--text-muted)', fontSize: '11px' }}>Typ realizacji:</span>
          <select
            value={formData.typ_realizacji}
            onChange={(e) => setFormData(prev => ({ ...prev, typ_realizacji: e.target.value }))}
            style={{ width: '100%', padding: '6px 10px', fontSize: '12px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)', marginTop: '2px' }}
          >
            <option value="do_odbioru">Do odbioru</option>
            <option value="dostawa">Dostawa</option>
            <option value="na_miejscu">Na miejscu</option>
          </select>
        </div>
        <div>
          <span style={{ color: 'var(--text-muted)', fontSize: '11px' }}>Lokalizacja:</span>
          <select
            value={formData.location_id}
            onChange={(e) => setFormData(prev => ({ ...prev, location_id: parseInt(e.target.value) }))}
            style={{ width: '100%', padding: '6px 10px', fontSize: '12px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)', marginTop: '2px' }}
          >
            {availableLocations.map(loc => (
              <option key={loc.id} value={loc.id}>{loc.nazwa}</option>
            ))}
          </select>
        </div>
      </div>
      <div style={{ marginTop: '0.4rem' }}>
        <span style={{ color: 'var(--text-muted)', fontSize: '11px' }}>Uwagi:</span>
        <textarea
          rows="2"
          value={formData.uwagi}
          onChange={(e) => setFormData(prev => ({ ...prev, uwagi: e.target.value }))}
          placeholder="Opcjonalne uwagi do zamowienia..."
          style={{ width: '100%', padding: '0.3rem 0.4rem', fontSize: '10px', border: '1px solid var(--border)', borderRadius: '3px', resize: 'vertical', marginTop: '2px', boxSizing: 'border-box' }}
        />
      </div>
    </div>
  );
};

export default OrderSettingsPanel;
